import { useTranslation } from "react-i18next";

type Lang = "en" | "es" | "fr" | "pt";

export function useLocalizedField<_T = unknown>() {
  const { i18n } = useTranslation();
  const lang = (i18n.language?.slice(0, 2) as Lang) ?? "en";
  return function pick(row: unknown, base: string): string {
    if (!row || typeof row !== "object") return "";
    const obj = row as Record<string, unknown>;
    const localized = obj[`${base}_${lang}`];
    if (typeof localized === "string" && localized.length) return localized;
    const en = obj[`${base}_en`];
    return typeof en === "string" ? en : "";
  };
}
